/* tslint:disable */
/* eslint-disable */
export enum FieldAttributes {
  PrivateScope = 'PrivateScope',
  Private = 'Private',
  FamAndAssem = 'FamANDAssem',
  Assembly = 'Assembly',
  Family = 'Family',
  FamOrAssem = 'FamORAssem',
  Public = 'Public',
  FieldAccessMask = 'FieldAccessMask',
  Static = 'Static',
  InitOnly = 'InitOnly',
  Literal = 'Literal',
  NotSerialized = 'NotSerialized',
  HasFieldRva = 'HasFieldRVA',
  SpecialName = 'SpecialName',
  RtSpecialName = 'RTSpecialName',
  HasFieldMarshal = 'HasFieldMarshal',
  PinvokeImpl = 'PinvokeImpl',
  HasDefault = 'HasDefault',
  ReservedMask = 'ReservedMask'
}
